import styled, { keyframes } from "styled-components";
import { MdKeyboardArrowRight, MdArrowForward } from 'react-icons/md';

const fadeInUp = keyframes`
    from {
        opacity: 0;
        transform: translateY(30px);
    }
    to {
        opacity: 1;
        transform: translateY(0);
    }
`;

export const HeroContainer = styled.div`
    background: #0c0c0c;
    display: flex;
    align-items: center;
    padding: 0 30px;
    height: 100vh;
    min-height: 800px;
    position: relative;
    z-index: 1;

    @media screen and (max-width: 768px) {
        flex-direction: column;
        padding: 100px 20px 40px;
        height: auto;
        min-height: 100vh;
    }
`

export const HeroContentWrapper = styled.div`
    flex: 1;
    display: flex;
    justify-content: center;
    align-items: center;
    padding-right: 30px;

    @media screen and (max-width: 768px) {
        padding-right: 0;
        padding-bottom: 40px;
        text-align: center;
    }
`;

export const HeroVideoWrapper = styled.div`
    flex: 1;
    height: 60vh;
    border-radius: 20px;
    overflow: hidden;
    box-shadow: 0 20px 40px rgba(0,0,0,0.3);

    @media screen and (max-width: 768px) {
        width: 100%;
        height: 40vh;
        margin-bottom: 0;
        border-radius: 20px;
        overflow: hidden;
        transform: translateZ(0);
    }
`;

export const HeroBg = styled.div`
    width: 100%;
    height: 100%;
`

export const VideoBg = styled.video`
    width: 100%;
    height: 100%;
    object-fit: cover;
    background: #232a34;
`

export const HeroContent = styled.div`
    z-index: 3;
    max-width: 600px;
    display: flex;
    flex-direction: column;
    align-items: flex-start;

    @media screen and (max-width: 768px) {
        align-items: center;
    }
`

export const HeroH1 = styled.h1`
    background: linear-gradient(135deg, #ffffff 0%,rgb(150, 224, 251) 50%, #ffffff 100%);
    background-size: 200% 200%;
    -webkit-background-clip: text;
    background-clip: text;
    -webkit-text-fill-color: transparent;
    animation: gradientShift 6s ease-in-out infinite;
    font-size: 72px;
    text-align: left;
    font-family: 'Inter', 'Roboto', -apple-system, BlinkMacSystemFont, 'Segoe UI', sans-serif;
    font-weight: 700;
    line-height: 1.1;
    margin-bottom: 32px;
    letter-spacing: -2px;
    max-width: 900px;
    position: relative;

    @keyframes gradientShift {
        0% {
            background-position: 0% 50%;
        }
        50% {
            background-position: 100% 50%;
        }
        100% {
            background-position: 0% 50%;
        }
    }

    @media screen and (max-width: 768px) {
        font-size: 56px;
        text-align: center;
        line-height: 1.2;
        letter-spacing: -1.5px;
        margin-bottom: 24px;
    }

    @media screen and (max-width: 480px) {
        font-size: 44px;
        line-height: 1.3;
        letter-spacing: -1px;
        margin-bottom: 20px;
    }
`

export const HeroP = styled.p`
    margin-top: 0;
    margin-bottom: 24px;
    color: rgba(255, 255, 255, 0.9);
    font-size: 28px;
    text-align: left;
    max-width: 550px;
    line-height: 1.5;
    font-weight: 400;
    letter-spacing: 0.2px;
    animation: ${fadeInUp} 1s ease-out 0.3s both;

    @media screen and (max-width: 768px) {
        font-size: 20px;
        text-align: center;
        margin-bottom: 40px;
        max-width: 700px;
        line-height: 1.6;
    }

    @media screen and (max-width: 480px) {
        font-size: 20px;
        margin-bottom: 32px;
        max-width: 100%;
        line-height: 1.6;
    }
`

export const GradientText = styled.span`
    background: linear-gradient(135deg,rgb(182, 235, 251) 0%,rgb(201, 220, 251) 100%);
    -webkit-background-clip: text;
    background-clip: text;
    -webkit-text-fill-color: transparent;
`;

export const HeroBtnWrapper = styled.div`
    margin-top: 10px;
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    gap: 20px;
    animation: ${fadeInUp} 1s ease-out 0.5s both;

    @media screen and (max-width: 768px) {
        align-items: center;
    }

    @media screen and (max-width: 480px) {
        gap: 16px;
    }
`

export const DownloadSection = styled.div`
    margin-top: 32px;
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    gap: 16px;
    animation: ${fadeInUp} 1s ease-out 1s both;

    @media screen and (max-width: 768px) {
        align-items: center;
        margin-top: 24px;
        gap: 12px;
    }

    @media screen and (max-width: 480px) {
        margin-top: 20px;
        gap: 10px;
    }
`

export const DownloadText = styled.p`
    color: rgba(255, 255, 255, 0.8);
    font-size: 17px;
    font-weight: 500;
    margin-bottom: 8px;
    letter-spacing: 0.3px;

    @media screen and (max-width: 768px) {
        font-size: 15px;
    }

    @media screen and (max-width: 480px) {
        font-size: 14px;
        margin-bottom: 4px;
    }
`

export const StoreButtonsWrapper = styled.div`
    display: flex;
    flex-direction: row;
    gap: 16px;
    align-items: center;

    @media screen and (max-width: 480px) {
        flex-direction: column;
        gap: 12px;
    }
`

export const StoreButton = styled.a`
    display: flex;
    align-items: center;
    justify-content: center;
    width: 160px;
    transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
    opacity: 0.9;
    padding: 0;

    &:hover {
        transform: translateY(-2px);
        opacity: 1;
    }

    &:active {
        transform: translateY(-1px);
    }

    @media screen and (max-width: 768px) {
        width: 150px;
    }

    @media screen and (max-width: 480px) {
        width: 140px;
    }
`

export const StoreImg = styled.img`
    width: 100%;
    height: auto;
    object-fit: contain;
`

export const ArrowForward = styled(MdArrowForward)`
    margin-left: 8px;
    font-size: 20px;
`

export const ArrowRight = styled(MdKeyboardArrowRight)`
    margin-left: 8px;
    font-size: 20px;
`

export const Img = styled.img`
    width: 140px;
    height: auto;
    margin: 0 8px;

    @media screen and (max-width: 768px) {
        width: 120px;
        margin: 0 6px;
    }

    @media screen and (max-width: 480px) {
        width: 100px;
        margin: 0 4px;
    }
`

export const Button = styled.button`
    border-radius: 16px;
    background: ${({primary}) => (primary ? '#38A7BA' : '#010606')};
    white-space: nowrap;
    padding: ${({big}) => (big ? '16px 40px' : '14px 32px')};
    color: ${({dark}) => (dark ? '#ffffff' : '#fff')};
    font-size: ${({fontBig}) => (fontBig ? '18px' : '16px')};
    font-weight: 500;
    outline: none;
    border: none;
    cursor: pointer;
    justify-content: center;
    align-items: center;
    transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
    text-decoration: none;
    box-shadow: 0 4px 16px rgba(0, 0, 0, 0.12);
    letter-spacing: 0.3px;
    display: inline-flex;
    position: relative;
    overflow: hidden;

    &:before {
        content: '';
        position: absolute;
        top: 0;
        left: -100%;
        width: 100%;
        height: 100%;
        background: linear-gradient(90deg, transparent, rgba(255,255,255,0.1), transparent);
        transition: left 0.6s;
    }

    &:hover {
        transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
        background: ${({primary}) => (primary ? '#2E8A99' : '#38A7BA')};
        transform: translateY(-2px);
        box-shadow: 0 8px 24px rgba(56, 167, 186, 0.3);
        color: #fff;

        &:before {
            left: 100%;
        }
    }

    &:active {
        transform: translateY(-1px);
        box-shadow: 0 4px 16px rgba(0, 0, 0, 0.15);
    }

    @media screen and (max-width: 768px) {
        padding: ${({big}) => (big ? '14px 32px' : '12px 24px')};
        font-size: ${({fontBig}) => (fontBig ? '16px' : '14px')};
    }

    @media screen and (max-width: 480px) {
        padding: ${({big}) => (big ? '12px 24px' : '10px 20px')};
        font-size: ${({fontBig}) => (fontBig ? '14px' : '13px')};
    }
`